import { createDocumentRequest } from './helper';
export const getGenericDocumentById = createDocumentRequest({
    route: '/document/generic/documents/:documentId',
    method: 'get',
    source: 'data',
});
